import cn from 'classnames';
import renderDocument from 'modules/content-cms/util/render-document';
import React from 'react';
import Slider from 'react-slick';
import { ISectionBenefitsFields } from '../../../../global';
import ContentContainer from '../components/content-container';
import Image from '../components/image';
import Title from '../components/title';
import styles from './benefits.module.css';

const sliderSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  mobileFirst: true,
  arrows: false,
  dots: true,
  dotsClass: cn(styles.dot, 'pt-4 flex items-center justify-center w-full'),
  customPaging: function (i: number) {
    return (
      <button
        className="mx-1 h-3 w-3 rounded-full border border-grey-500 bg-transparent focus:outline-hidden"
        aria-label="Slide wechseln"
      ></button>
    );
  },
  responsive: [
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        centerMode: false,
        dots: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
      },
    },
  ],
};

const Benefits: React.FC<ISectionBenefitsFields> = ({
  title,
  backgroundColor,
  benefits,
}) => {
  const renderImage = (benefit: any) => {
    if (benefit.fields.imageLink) {
      return (
        <a href={benefit.fields.imageLink}>
          <Image
            {...benefit.fields.image}
            className="h-auto w-full rounded-full"
          />
        </a>
      );
    } else {
      return (
        <Image
          {...benefit.fields.image}
          className="h-auto w-full rounded-full"
        />
      );
    }
  };

  return (
    <ContentContainer backgroundColor={backgroundColor}>
      {title && <Title>{title}</Title>}

      {benefits && benefits.length > 0 && (
        <div className="-mx-6 md:mx-0">
          <Slider {...sliderSettings}>
            {benefits.map((benefit) => (
              <div key={benefit.sys.id} className="w-full px-6 md:px-0">
                <div
                  key={benefit.sys.id}
                  className="mx-auto max-w-3xl items-center md:flex"
                >
                  <div className="mx-auto max-w-sm px-10 pb-5 md:mx-0 md:w-1/3 md:max-w-5xl md:px-0 md:pb-0">
                    {renderImage(benefit)}
                  </div>
                  <div className="flex flex-col items-center text-center md:w-2/3 md:flex-row md:pl-16 md:text-left">
                    <div className="w-16">
                      {benefit.fields.icon && (
                        <Image
                          {...benefit.fields.icon}
                          className="h-auto w-16"
                        />
                      )}
                    </div>
                    <div className="pt-5 md:pl-6 md:pt-0">
                      {renderDocument(benefit.fields.text)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      )}
    </ContentContainer>
  );
};

export default Benefits;
